import React from 'react';
import Svg from '../Svg';

const IconCloud02 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.02165 10.407C4.3251 6.26563 7.78119 3 12 3C15.9177 3 19.1766 5.81531 19.8658 9.53369C21.7183 10.4177 23 12.3081 23 14.5C23 17.5376 20.5376 20 17.5 20H6C3.23858 20 1 17.7614 1 15C1 12.9404 2.24457 11.1735 4.02165 10.407ZM12 5C8.68629 5 6 7.68629 6 11C6 11.0361 6.00032 11.0722 6.00095 11.1081C6.00911 11.571 5.69847 11.979 5.25009 12.0942C3.95553 12.427 3 13.6032 3 15C3 16.6569 4.34315 18 6 18H17.5C19.433 18 21 16.433 21 14.5C21 12.9659 20.0124 11.6598 18.6353 11.1879C18.268 11.0621 18.0067 10.735 17.9652 10.349C17.6414 7.34197 15.0935 5 12 5Z"
    />
  </Svg>
);

export default IconCloud02;
